import type {
  ConfiguredUpliftEntity,
  ConfiguredUpliftWithAmount,
  FetchConfiguredUpliftPayload,
  WireAmount,
} from './types'

/** One key per scope, because a client answer and a venue answer are different answers. */
export const scopeKeyOf = ({ employer_id, work_location_id }: FetchConfiguredUpliftPayload) =>
  [employer_id, work_location_id ?? ''].join(':')

/**
 * The wire sends the amount as a decimal string ("3.0"); rendering it as typed is not money.
 * Anything that does not parse to a finite number is treated as nothing set, so the card stays
 * hidden rather than rendering "NaN".
 */
export const normaliseAmount = (amount?: WireAmount) => {
  if (amount === null || amount === undefined) return null
  // Number('') is 0, which would read as a configured zero rather than nothing set.
  if (typeof amount === 'string' && amount.trim() === '') return null

  const parsed = Number(amount)

  return Number.isFinite(parsed) ? parsed : null
}

/** True when the scope has an amount configured, so there is something for the card to show. */
export const hasConfiguredAmount = (
  uplift?: ConfiguredUpliftEntity | null,
): uplift is ConfiguredUpliftWithAmount => !!uplift && uplift.amount !== null
